<template>
  <footer class="c-footer" data-scroll-section>
    <span class="copyright">© 2020 OCEAN TRICO All rights reserved.</span>
    <div class="c-footer__page-top" @click="onScrollToTop">
      <svg
        class="arrow"
        width="19"
        height="34"
        viewBox="0 0 19 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 17L19 0V3.51888L4.408 17H0Z" fill="#E40718" />
        <path d="M16.5 9.5L19 7V34L16.5 34V9.5Z" fill="#E40718" />
      </svg>

      <img src="@/assets/page-top.png" alt="" />
    </div>
  </footer>
</template>

<script>
import smoothscroll from 'smoothscroll-polyfill'

export default {
  created() {
    smoothscroll.polyfill()
  },

  methods: {
    onScrollToTop() {
      if (window.lmS) {
        window.lmS.scrollTo(0)
      } else {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.c-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .copyright {
    display: inline-block;
    color: #fff;
    padding: 1rem;
    font-size: 1.2rem;
    margin: auto 0 0;
    @media screen and (max-width: $breakpoint-mobile) {
      font-size: 1rem;
      text-align: left;
    }
  }

  &__page-top {
    position: relative;
    cursor: pointer;

    .arrow {
      position: absolute;
      right: 3rem;
      top: 5rem;
    }
  }
}
</style>
